<div class="mt">
  <pr-input-column
    label="En cas de désignation nominative, merci d'indiquer les coordonnées complètes obligatoires de chaque bénéficiaire : nom de naissance, nom d'usage, prénom(s) d'état civil (exhaustivité par ordre d'état civil), prénom d'usage, date de naissance, commune et département de naissance, pays de naissance, adresse ; à défaut les héritiers de l'assuré."
    [derrors]="derrors"
    [isDefault]="false"
  >
    <textarea
      class="full-w"
      type="text"
      placeholder="Commencez à écrire ici"
      rows="6"
      formControlName="avClauseBeneficiaireLibre"
    ></textarea>
  </pr-input-column>
</div>
